import { FormElems } from '../../components/';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import deleteImage from '../../static/images/delete.png';
import './integrationTab.scss';
import { toast } from 'react-toastify';
import { AlertModal } from '../../components/';

const RenderDomainFields = ({ fields, isViewMode}) => {
    const [copied, setCopied] = useState([]);
    const [isShowModal, setIsShowModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleCopy = (index,e) => {
        {
            const value= fields.get(index);
            e.preventDefault();
            navigator.clipboard
                .writeText(value.domain)
                .then(() => {
                    toast.success('Link copied to clipboard');
                    setCopied((prev)=>{
                        let newState = [...prev];
                        newState[index] = true;
                        return newState;
                    })
                    setTimeout(() =>setCopied((prev)=>{
                        let newState = [...prev];
                        newState[index] = false;
                        return newState;
                    }),  2000);
                })
                .catch(() => {
                    alert('Copy failed. Please try again manually.');
                });
        }
    };

    const onSuccessModal = () => {
        setIsShowModal(false);
    };

    return (
        <div>
            <div className='domain_heading'>
                <p className="field-name">Domain</p>
                {fields.length < 5 && !isViewMode &&(
                <div className="wrapper-container">
                    <p className="add-more" onClick={() => fields.push({})}>
                        + Add More
                    </p>
                </div>
            )}
            </div>

            {fields.map((field, index) => (
                <div key={index} className="form-section dynamic-fields">
                    <div className='domains'>
                        <div className="form-field field-name-container">
                            <Field
                                name={`${field}.domain`}
                                component={FormElems.Input}
                                placeholder="Enter Whitelisting Domain"
                                labelField="name"
                                valueField="value"
                                label="Enter Whitelisting Domain"
                                disabled={isViewMode}
                            />
                        </div>
                        <div className="link">
                            <button
                                    className={`copy`} title="Copy Link"
                                    onClick={(e) => handleCopy(index,e)}
                                    >
                            </button>
                        </div>
                        {!isViewMode &&(
                            <>
                            <div className="delete-icon">
                                <button
                                    type="button"
                                    title='Delete'
                                    onClick={() => {
                                        if (fields.length === 1) {
                                            setErrorMessage('A minimum of one domain and a maximum of five domains must be provided.');
                                            setIsShowModal(true);
                                        } else {
                                            fields.remove(index);
                                        }
                                    }}
                                >
                                    <img
                                        src={deleteImage}
                                        alt="Delete"
                                        className="delete-icon"
                                    />
                                </button>
                            </div>
                            </>
                        )}
                    </div>
                </div>
            ))}

            <AlertModal
                headerText="Alert"
                modalIsOpen={isShowModal}
                primaryButtonText="OK"
                showActions={true}
                onSuccessModal={onSuccessModal}
                message={errorMessage}
            />

        </div>
    );
};

RenderDomainFields.propTypes = {
    fields: PropTypes.object.isRequired,
    isViewMode: PropTypes.bool,
};

export default RenderDomainFields;
